<template>
	<div class="seomain">
		<st-header
		  :title="formData.id ? '编辑客户' : '添加客户'"
		  :back-able="true"
		>
		</st-header>
		
		<div class="st-form-content">
			 <st-form ref="form">
				 <div>
					 <div class="st-form-title">基本信息</div>
					 <div class="info-card">
							<p>采购编号: T-2411-0511-0628-7262</p>
							<p>采&nbsp;购&nbsp;&nbsp;员: 丁泽宇</p>
							<p>采购日期: 2024年11月05日</p>
							<p>预计交期: 2024年11月06日</p>
							<p>采购区域: 境内</p>
							<p>备&emsp;&emsp;注: 采购图野三星D5 64G 4800*2624片，销售用。月结。【变更数量】</p>
						</div>
						
						<div class="st-form-title">物流信息</div>
						<div class="st-form-group">
							<van-cell-group inset>
								<st-form-item key="purchasingtracking" label="物流商" prop="purchasingtracking">
									<st-select
									  v-model="formData['purchasingtracking']"
									  name="物流商"
									  placeholder="请选择物流商"
									  :options="$option['getExpress']"
										:def-text="formData['purchasingtracking_name']"
									>
									</st-select>
								</st-form-item>
								
								<st-form-item key="country_id" label="收货人手机号" prop="country_id">
									 <van-field
										 class="st-form-item-input"
										 v-model="formData.country_id"
										 name="收货人手机号"
										 label=""
										 placeholder="请填写收货人手机号"
									 />
								</st-form-item>
								
								<st-form-item key="country_id" label="物流单号" prop="country_id">
									 <van-field
										 class="st-form-item-input"
										 v-model="formData.country_id"
										 name="物流单号"
										 label=""
										 placeholder="请填写物流单号"
									 />
								</st-form-item>
								
								<st-form-item key="currency" label="运费币种" prop="currency">
								  <st-select
								    v-model="formData.currency"
								    name="运费币种"
								    placeholder="请选择运费币种"
								    :options="$option['getCurrency']"
										ref="currency-select"
								  >
								  </st-select>
								</st-form-item>
								
								<st-form-item key="exchange_rate" label="运费汇率" prop="exchange_rate">
								  <van-field
								    class="st-form-item-input"
								    v-model="formData.exchange_rate"
								    name="运费汇率"
								    label=""
								    placeholder="请输入运费汇率"
								  />
								</st-form-item>
								
								<st-form-item key="exchange_rate" label="运费" prop="exchange_rate">
								  <van-field
								    class="st-form-item-input"
								    v-model="formData.exchange_rate"
								    name="运费"
								    label=""
								    placeholder="请输入运费"
								  />
								</st-form-item>
								
								<st-form-item key="exchange_rate" label="其他费用" prop="exchange_rate" style="position: relative;">
								  <van-field
								    class="st-form-item-input"
								    v-model="formData.exchange_rate"
								    name="其他费用"
								    label=""
								    placeholder="请输入其他费用"
								  />
									<span style="position: absolute;right: 2px;top: 30px;background: rgb(226 216 216 / 50%);padding: 11px 26px;">CNY</span>
								</st-form-item>
								
								<st-form-item key="ctn_count" label="箱数" prop="ctn_count">
								  <van-field
								    class="st-form-item-input"
								    v-model="formData.ctn_count"
								    name="箱数"
								    label=""
								    placeholder="请输入箱数"
								  />
								</st-form-item>
							</van-cell-group>
						</div>
						
						<div style="margin: 16px;" class="form-submit-button">
						  <van-button round block type="primary"  @click="onSubmit">
						    提交
						  </van-button>
						</div>
				 </div>
			 </st-form>
		</div>
	</div>
</template>

<script>
	import StHeader from "@/components/layout/Header.vue";
	import StFormItem from "@/components/formItem.vue";
	import StForm from "@/components/form.vue";
	import StFileUpload from "@/components/FileUpload.vue";
	import StSelect from "@/components/Select.vue";
	import StDate from "@/components/Date.vue";

	export default {
		components: {
			StHeader,
			StFormItem,
			StForm,
			StFileUpload,
			StSelect,
			StDate,
			floading: false,
		},
		props: {},
		data() {
		  return {
				act_step: 0,
		    formData: {
				},
			}
		},
		watch: {},
		created() {
		  this.init();
		},
		mounted() {},
		methods: {
		    init() {
					let query = this.$route.query;
					if (query.id) this.formData.id = query.id;
					this.getInfo();
		    },
				getInfo() {
						if(!this.formData.id) {
							return;
						}
						this.floading = true;
						
						// this.$post(this.$api.stCustomerInfo, {id: this.formData.id}).then((res) => {
						// 	if (res.code != 1) {
						// 		this.$toast.fail(res.msg ? res.msg : '获取异常');
						// 		return;
						// 	}
						// 	let data = res.data;
						// 	let formData = {};
						// 	this.$set(this, ['formData'], formData);
						// 	this.floading = false;
						// });
				},
				
		    // 提交代码
		    onSubmit() {
		      let formValid = false;
		      this.$refs.form.validater.valid((isValid, lastMsg) => { 
		        formValid = isValid;
		        if (!isValid) {
		          this.$toast.fail('表单异常：' + lastMsg);
		        }
		      });
		      // 校验不通过
		      if (!formValid) return;
		      let formData = JSON.parse(JSON.stringify(this.formData));
					if (!this.formData.id) {
						this.$post(this.$api.stCustomerAdd, formData).then((res) => {
						  if (res.code !== 1) {
						    this.$toast.fail(res.msg ? res.msg : '保存异常');
						  } else {
						    this.$toast.success("创建客户成功");
						    this.$router.replace('/customer/list');
						  }
						});
					} else {
						this.$post(this.$api.stCustomerEdit, formData).then((res) => {
						  if (res.code !== 1) {
						    this.$toast.fail(res.msg ? res.msg : '保存异常');
						  } else {
						    this.$toast.success("编辑客户成功");
						    this.$router.replace('/customer/list');
						  }
						});
					}
		      
		      
		    },
		  },
		
	}
</script>

<style lang="scss" scoped>
.info-card {
	background: white;
	margin-bottom: 26px;
	border-radius: 5px;
	p {
		padding: 6px 12px;
	}
	
}	
.st-form-content {
  margin: 20px 15px;
	overflow: hidden;
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding: 8px 6px 10px 6px;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      padding-bottom: 10px;
    }

  }

}

</style>